module.exports = ":host ::ng-deep tr > ::ng-deep td {\r\n    border-width: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-view/confirmation-view.component.css
// module id = ./src/app/shared/components/confirmation-view/confirmation-view.component.css
// module chunks = main